import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import {
  FETCH_SETTINGS_REQUEST,
  fetchSettingsSuccess,
  fetchSettingsFailure,
  UPDATE_SETTINGS_REQUEST,
  updateSettingsSuccess,
  updateSettingsFailure,
} from '../actions/settingsActions';

import { getBaseUrl } from '../utils/getBaseUrl';

// Helper function to get the auth token
const getAuthToken = () => localStorage.getItem('authToken');
const API_BASE_URL = getBaseUrl();

// Worker Saga: Fetch Settings
function* fetchSettings() {
  try {
    const token = getAuthToken();
    const response = yield call(axios.get,   `${API_BASE_URL}/settings`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    yield put(fetchSettingsSuccess(response.data));
  } catch (error) {
    yield put(fetchSettingsFailure(error.response?.data?.message || error.message));
  }
}

// Worker Saga: Update Settings
function* updateSettings(action) {
  try {
    const token = getAuthToken();
    const response = yield call(
      axios.put,
      `${API_BASE_URL}/settings`,
      action.payload,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    yield put(updateSettingsSuccess(response.data));
  } catch (error) {
    yield put(updateSettingsFailure(error.response?.data?.message || error.message));
  }
}

// Watcher Saga
function* settingsSaga() {
  yield takeLatest(FETCH_SETTINGS_REQUEST, fetchSettings);
  yield takeLatest(UPDATE_SETTINGS_REQUEST, updateSettings);
}

export default settingsSaga;
